import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
interface SectionLinkProps {
  id: string;
  className?: string;
  children: React.ReactNode;
}
export function SectionLink({
  id,
  className,
  children
}: SectionLinkProps) {
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (pathname === '/') {
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }
    navigate('/', {
      state: {
        scrollTo: id
      }
    });
  };
  return <a href={`#${id}`} onClick={handleClick} className={className} data-id="element-91" data-mp="bjgrmy3x5h2h">
      {children}
    </a>;
}